import React from 'react';
import { Box } from '@mui/material';
import { KOLOM_58MM, sajikanBaris } from './strukLayout';
import { svgQr } from './qrStruk';

/** Tampilan struk di layar: baris yang sama persis dengan yang dicetak (monospace, selebar kertas). */
const StrukPratinjau = ({ baris, kolom = baris.kolom || KOLOM_58MM }) => (
  <Box
    sx={{
      display: 'inline-block',
      bgcolor: '#fff',
      color: '#111',
      border: '1px solid #ddd',
      boxShadow: 1,
      p: 1.5,
      fontFamily: '"Courier New", monospace',
      fontSize: 13,
      lineHeight: 1.25,
      width: `calc(${kolom}ch + 24px)`,
      maxWidth: '100%',
      overflowX: 'auto',
    }}
  >
    {sajikanBaris(baris, kolom).map((b, i) => {
      if (b.gambar) {
        return (
          <Box key={i} sx={{ textAlign: 'center' }}>
            <img src={b.gambar} alt="" style={{ maxWidth: '100%', maxHeight: 50, objectFit: 'contain' }} />
          </Box>
        );
      }
      if (b.qr) {
        return <Box key={i} data-qr="ulasan" sx={{ display: 'flex', justifyContent: 'center', '& svg': { width: 120, height: 120 } }} dangerouslySetInnerHTML={{ __html: svgQr(b.qr) }} />;
      }
      return <Box key={i} sx={{ whiteSpace: 'pre', fontWeight: b.tebal ? 700 : 400, minHeight: '1.25em' }}>{b.teks}</Box>;
    })}
  </Box>
);

export default StrukPratinjau;
